export default "__VITE_ASSET__C9z9ynxK__"